import { useState } from 'react';
import * as Form from './form';
import './Styles/SortDropdown.css';
import { SortOrder } from '../utils/bubbles/sort';

export type SortItem = { key: string; value: string };

interface SortDropdownProps<Item extends SortItem> {
    label: string;
    items: readonly Item[];
    onSort?: (optionKey: Item['key'], order: SortOrder) => void;
}

export function SortDropdown<Item extends SortItem>({ label, items, onSort: onSelect }: SortDropdownProps<Item>) {
    const [selectedOption, setSelectedOption] = useState<string | null>(null);
    const [sortOrder, setSortOrder] = useState<SortOrder>('ASC');

    return (
        <>
            <div className='dropdown-menu-container'>
                <b className='dropdown-menu-header'>{label.toUpperCase()}</b>
                <div className='dropdown-menu-items mb-[8px]'>
                    {items.map((item) => (
                        <label key={item.key} className='dropdown-menu-item'>
                            <Form.Radio
                                name='sortType'
                                value={item.key}
                                checked={selectedOption === item.key}
                                onChange={() => {
                                    setSelectedOption(item.key);
                                    onSelect?.(item.key, sortOrder);
                                }}
                            />
                            {item.value}
                        </label>
                    ))}
                </div>
                <div className='dropdown-menu-items'>
                    <label className='dropdown-menu-item'>
                        <Form.Radio
                            name='sortOrder'
                            value='asc'
                            checked={sortOrder === 'ASC'}
                            onChange={() => {
                                setSortOrder('ASC');
                                selectedOption && onSelect?.(selectedOption, 'ASC');
                            }}
                        />
                        Ascending
                    </label>
                    <label className='dropdown-menu-item'>
                        <Form.Radio
                            name='sortOrder'
                            value='desc'
                            checked={sortOrder === 'DESC'}
                            onChange={() => {
                                setSortOrder('DESC');
                                selectedOption && onSelect?.(selectedOption, 'DESC');
                            }}
                        />
                        Descending
                    </label>
                </div>
            </div>
        </>
    );
}
